import { handleActions } from 'redux-actions';
import { Constants } from './types'

const initialState = {
  deleting: null,
};

const reducer = handleActions({
  [Constants.SET_ORGANIZATION_EDIT]: (state: any, action: any) => {
    const { payload: id } = action;

    return {
      ...state,
      editing: state.list.find((o: /* Organization */any) => o.id === id),
    };
  },
  [Constants.SET_ORGANIZATION_DELETE]: (state: any, action: any) => {
    const { payload: id } = action;

    return {
      ...state,
      deleting: state.list.find((o: /* Organization */any) => o.id === id),
    };
  },
},                            initialState);

export default reducer;
